export default __webpack_public_path__ + "static/media/working.7d63565e.png";